import pickmeup from 'pickmeup'; // import with changed language

import Pristine from '../../js/vendors/pristine.js';
Pristine.addValidator("contact", function (value) {
  return /^\d{11}$/.test(value) || /^\+\d{11}$/.test(value) || /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(value);
}, "Пожалуйста, введите адрес электронной почты или телефон.");
document.querySelectorAll(".js-fields").forEach(function (fields) {
  var rows = fields.querySelector('.js-fields-rows');
  fields.querySelector('.js-fields-add').addEventListener('click', function (event) {
    var row = fields.querySelector('.js-fields-row').cloneNode(true);
    rows.appendChild(row);
    row.querySelectorAll('input:not([type=radio]),input:not([type=checkbox]),textarea').forEach(function (input) {
      input.value = '';
    });
  });
}); // document.querySelectorAll("label.field--file").forEach(field => {
//   let input = field.querySelector('input'),
//     span = field.querySelector('span');
//   input.addEventListener('change', evt => {
//     if (input.value) {
//       let filename = input.value.substring((input.value.indexOf('\\') >= 0 ? input.value.lastIndexOf('\\') : input.value.lastIndexOf('/')));
//       if (filename.indexOf('\\') === 0 || filename.indexOf('/') === 0) {
//         filename = filename.substring(1);
//       }
//       span.innerText = filename;
//     }
//   });
// });

document.querySelectorAll("form.js-validate").forEach(function (form) {
  var pristine = new Pristine(form, {
    // class of the parent element where the error/success class is added
    classTo: 'field__container',
    errorClass: 'error',
    successClass: 'success',
    // class of the parent element where error text element is appended
    errorTextParent: 'field__container',
    // type of element to create for the error text
    errorTextTag: 'div',
    // class of the error text element
    errorTextClass: 'field__container-msg'
  });
  form.addEventListener('submit', function (evt) {
    if (!pristine.validate()) {
      evt.preventDefault();
    }
  });
});
document.querySelectorAll('.js-select-all').forEach(function (el) {
  return el.addEventListener('click', function (event) {
    event.stopPropagation();
    var list = event.target.parents('.js-select');

    if (list.length && list[0]) {
      list[0].querySelectorAll('input[type="checkbox"]').forEach(function (checkbox) {
        return checkbox.checked = true;
      });
    }
  });
});
document.querySelectorAll('.js-select-none').forEach(function (el) {
  return el.addEventListener('click', function (event) {
    event.stopPropagation();
    var list = event.target.parents('.js-select');

    if (list.length && list[0]) {
      list[0].querySelectorAll('input[type="checkbox"]').forEach(function (checkbox) {
        return checkbox.checked = false;
      });
    }
  });
});
document.querySelectorAll('.js-select-toggle').forEach(function (el) {
  return el.addEventListener('change', function (event) {
    event.stopPropagation();
    var list = event.target.parents('.js-select');

    if (list.length && list[0]) {
      list[0].querySelectorAll('input[type="checkbox"]').forEach(function (checkbox) {
        return checkbox.checked = event.target.checked || false;
      });
    }
  });
});
document.querySelectorAll("label.field--file").forEach(function (container) {
  container.querySelector('input').addEventListener('input', function (event) {
    container.querySelectorAll('.field__preview').forEach(function (el) {
      return el.parentNode.removeChild(el);
    });
    Array.prototype.forEach.call(event.target.files, function (file) {
      switch (file.type) {
        case 'image/png':
        case 'image/jpeg':
        case 'image/bmp':
        case 'image/tiff':
        case 'image/gif':
        case 'image/webp':
          var reader = new FileReader();

          reader.onload = function (evt) {
            var preview = document.createElement('div');
            preview.classList.add('field__preview');
            var img = document.createElement('img');
            img.src = evt.target.result;
            preview.appendChild(img);
            container.insertBefore(preview, event.target);
          };

          reader.readAsDataURL(file);
          break;

        default:
          break;
      }
    });
  });
});
document.querySelectorAll('.field__container--items').forEach(function (el) {
  el.addEventListener('click', function (event) {
    el.classList.add('field--opened');
    document.querySelectorAll('.menu__wrapper').forEach(function (menu) {
      menu.classList.remove('opened');
    });
    document.documentElement.classList.remove('menu--opened');
  });
});
document.querySelectorAll('.field__items-close').forEach(function (el) {
  el.addEventListener('click', function (event) {
    el.closest('.field__items').parentNode.querySelector('.field__container--items').classList.remove('field--opened');
    document.querySelectorAll('.menu__wrapper').forEach(function (menu) {
      menu.classList.remove('opened');
    });
    document.documentElement.classList.remove('menu--opened');
  });
});

function toggleFieldList(evt) {
  var field = evt.target.closest('.field__items').parentNode.querySelector('.field__container--items input');
  var list = evt.target.closest('.field__items-list');
  var values = [];

  if (field) {
    list.querySelectorAll('input:checked').forEach(function (i) {
      values.push(i.closest('label').innerText);
    });
  }

  field.value = values.join(', ');
}

document.querySelectorAll('.field__items-list input').forEach(function (input) {
  input.addEventListener('change', toggleFieldList);
});
document.querySelectorAll('.field__items-search input').forEach(function (input) {
  input.addEventListener('keyup', function (evt) {
    var query = event.target.value,
        items = event.target.closest('.field__items').querySelectorAll('.field__items-select span:not(.not-found)');
    var count = 0;
    items.forEach(function (item) {
      if (!item.innerHTML.match(new RegExp('.*?' + query + '.*?', 'i'))) {
        item.style.display = 'none';
      } else {
        item.style.display = '';
        count++;
      }
    });
    event.target.closest('.field__items').querySelector('.field__items-select span.not-found').style.display = count ? 'none' : '';
  });
});
document.querySelectorAll('.field__items-select span').forEach(function (item) {
  item.addEventListener('click', function (evt) {
    var field = item.closest('.field__items').parentNode.querySelector('.field__container--items input');
    field.value = item.innerText;
    item.closest('.field__items').parentNode.querySelector('.field__container--items').classList.remove('field--opened');
    document.querySelectorAll('.menu__wrapper').forEach(function (menu) {
      menu.classList.remove('opened');
    });
    document.documentElement.classList.remove('menu--opened');
  });
});

function _search_select(event) {
  var query = event.target.value,
      count = 0;
  li.forEach(function (_li) {
    if (!_li.innerHTML.match(new RegExp('.*?' + query + '.*?', 'i'))) {
      _li.style.display = 'none';
    } else {
      _li.style.display = '';
      count++;
    }
  });

  if (options[0].innerText === '' && selectPlaceholder !== '') {
    li[0].style.display = 'none';
  }

  selectbox.querySelector('div.' + opt.classPrefix + '-selectbox__not-found').style.display = count ? 'none' : '';
}

pickmeup.defaults.locales['ru'] = {
  days: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
  daysShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
  daysMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
  months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
  monthsShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек']
};
pickmeup.defaults.locale = 'ru';
pickmeup.defaults.format = 'd.m.Y';
document.querySelectorAll('input.field--date').forEach(function (input) {
  var pseudo = document.createElement('span');
  pseudo.classList.add('field');
  pseudo.classList.add('field--date');
  pseudo.classList.add('field--pseudo');
  pseudo.innerText = input.value;
  input.parentNode.appendChild(pseudo);
  input.setAttribute('type', 'hidden');
  var calendar = pickmeup(input, {
    hide_on_select: true,
    date: input.value,
    min: input.getAttribute('min') || null,
    max: input.getAttribute('max') || null
  });
  input.addEventListener('pickmeup-change', function (evt) {
    pseudo.innerText = evt.detail.formatted_date;
  });
  pseudo.addEventListener('click', function (evt) {
    calendar.show();
    pseudo.innerText = input.value;
  });
});